import { css } from '@emotion/react';
import { Placement } from '@floating-ui/react-dom-interactions';
import { theme } from '@frontend/theme';
import { styles } from '../../../../styles';

const upperBoxShadow = '1px -5px 14px 2px rgb(49 53 61 / 24%)';

type DropdownMenuProps = { placement?: Placement | ''; maxHeight: number | null };

type DropdownOptionProps = { active: boolean; disabled?: boolean };

type InputProps = { disabled?: boolean };

const dropdownMenuStyle = ({ placement, maxHeight }: DropdownMenuProps) => [
  css`
    background: ${theme.colors.white};
    /* theme shadows blur the field label if the floating element renders above the trigger 
    /* this custom upperBoxShadow makes sure the label is visible */
    box-shadow: ${placement === 'top' ? upperBoxShadow : theme.shadows.floating};
    margin: 0;
    outline: none;
    padding: 0;
    max-height: 250px;
    ${styles.smallScrollbar(theme)}
  `,
  maxHeight &&
    css`
      max-height: ${maxHeight}px;
    `,
];

const dropdownOptionStyle = ({ active, disabled }: DropdownOptionProps) => [
  css`
    align-items: center;
    color: ${theme.colors.neutral90};
    cursor: default;
    display: flex;
    justify-content: space-between;
    min-height: 40px;
    outline: 0;
    padding: ${theme.spacing(1, 2)};
    width: 100%;
    .select-option-text {
      /* adding the break-all property because some values in our apps are very long and have no spaces */
      /* break-all prevents those values from causing overflow problems */
      word-break: break-all;
    }
  `,
  active &&
    css`
      background: ${theme.colors.neutral5};
    `,
  disabled &&
    css`
      .select-option-text {
        color: ${theme.colors.status.disabled};
      }
      :hover {
        background: none;
        cursor: not-allowed;
      }
    `,
];

export const inputStyle = ({ disabled }: InputProps) => [
  css`
    font-family: ${theme.font.family};
    font-size: ${theme.fontSize(16)};
    line-height: 1.375;
    padding-right: ${theme.spacing(4)};
    text-align: left;
    ${styles.truncate}
    > input[type='text'] {
      margin-right: 0;
      padding-right: ${theme.spacing(3)};
      ::placeholder {
        color: ${theme.colors.black};
      }
    }
  `,
  disabled &&
    css`
      color: ${theme.colors.status.disabled};
    `,
];

export const DropdownFieldStyles = {
  dropdownMenu: (dropdownMenuProps: DropdownMenuProps) => dropdownMenuStyle(dropdownMenuProps),
  dropdownOption: (dropdownOptionProps: DropdownOptionProps) => dropdownOptionStyle(dropdownOptionProps),
  dropdownInput: (dropdownInputProps: InputProps) => inputStyle(dropdownInputProps),
};
